module.exports = __webpack_public_path__ + "img/selected4-min.9ae581f8.png";